<template>
  <div class="flex flex-col gap-y-2 text-sm">
    <div class="flex gap-x-2">
      <div class="flex w-4 self-center mobile:hidden mobile-hidden">
        <span class="w-4 h-4 bg-primary rounded-full"></span>
      </div>
      <div class="flex flex-col w-full">
        <planning-location-selector
          v-model="fields.location"
          :emit-standardized-object="true"
          ref="startLocation"
          class="text-sm"
        >
          Lähtekoht
        </planning-location-selector>
        <div
          class="flex w-full text-sm mt-1"
          v-if="selectedProject || !fields.location"
        >
          <div
            v-if="
              !fields.location ||
              (fields.location && !fields.location.long_address)
            "
            class="flex items-center"
          >
            <button
              v-if="selectedProject"
              class="mr-2"
              @click="
                () =>
                  $refs.startLocation.selectLocation(
                    processLocationForEmit(selectedProject.location)
                  )
              "
              :class="selectedProject.location ? 'btn-primary' : 'btn-disabled'"
              :disabled="!selectedProject.location"
            >
              <span class="label">Tellimusega sama</span>
            </button>
            <button
              v-if="selectedProject"
              class="mr-2"
              :class="
                (selectedProject &&
                  selectedProject.client &&
                  selectedProject.client.location) ||
                (selectedProject && selectedProject.client_location)
                  ? 'btn-primary'
                  : 'btn-disabled'
              "
              @click="
                () =>
                  $refs.startLocation.selectLocation(
                    processLocationForEmit(
                      selectedProject.client && selectedProject.client.location
                        ? selectedProject.client.location
                        : selectedProject.client_location
                    )
                  )
              "
            >
              <span class="label">Tellimuse kliendiga sama</span>
            </button>
            <button
              v-if="selectedProject"
              class="mr-2"
              :class="fields.endLocation ? 'btn-primary' : 'btn-disabled'"
              @click="
                () =>
                  $refs.startLocation.selectLocation(
                    processLocationForEmit(fields.endLocation)
                  )
              "
              :disabled="!fields.endLocation"
            >
              <span class="label">Sama mis lõpp</span>
            </button>
          </div>
          <div
            v-if="selectedProject && selectedProject.contacts"
            class="flex items-center gap-x-1 ml-auto flex-wrap relative"
          >
            <div
              class="inline-block cursor-pointer"
              v-for="(contact, index) in selectedProject.contacts"
              :key="index"
              @mouseenter="contactHovered = `start${index}`"
              @mouseleave="contactHovered = null"
              @click.stop.prevent="
                appendToStartInfo(
                  `${contact.name}: ${contact.telephone_number}`
                )
              "
            >
              <div
                class="flex p-1 h-6 w-6 rounded shadow bg-primary justify-center items-center"
              >
                <span class="typcn typcn-phone text-white" />
              </div>
              <div
                v-if="contactHovered === `start${index}`"
                class="flex flex-col z-10 absolute p-1 -left-48 top-0 bg-white w-48 border rounded-md"
              >
                <div class="flex items-center justify-between">
                  <span class="font-medium">{{ contact.name }} </span>
                  <span>{{ contact.role }} </span>
                </div>
                <span>
                  {{ contact.telephone_number }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="extraLocations.length > 0" class="flex flex-col gap-y-1">
      <div
        v-for="(location, index) in extraLocations"
        :key="`l-${location.key}`"
        class="flex w-full gap-x-2"
      >
        <div class="flex flex-col w-full">
          <planning-location-selector
            :emit-standardized-object="true"
            :extra-location="true"
            ref="extraLocations"
            v-model="location.location"
            @delete="
              $store.dispatch('modals/addTaskModal/deleteExtraLocation', index)
            "
          >
            Vahesihtkoht
          </planning-location-selector>
        </div>
      </div>
    </div>
    <div
      v-if="fields.location && isManager"
      class="flex gap-x-2 cursor-pointer rounded-l-full rounded-r hover:bg-primary hover:bg-opacity-10 duration-100"
      @click="$store.dispatch('modals/addTaskModal/addExtraLocation')"
    >
      <div class="w-4 self-center">
        <button
          class="bg-primary h-4 w-4 rounded-full leading-none flex justify-center items-center text-white"
        >
          <span class="typcn typcn-plus leading-none"></span>
        </button>
      </div>
      <div class="flex font-medium">
        <span>Lisa vahesihtkoht</span>
      </div>
    </div>
    <div class="flex gap-x-2">
      <div class="flex w-4 relative self-center mobile:hidden mobile-hidden">
        <span class="w-4 h-4 bg-primary rounded-full"></span>
      </div>
      <div class="flex flex-col flex-1">
        <planning-location-selector
          v-model="fields.endLocation"
          :emit-standardized-object="true"
          ref="endLocation"
        >
          Sihtkoht
        </planning-location-selector>
        <div
          class="flex w-full text-sm mt-1"
          v-if="!fields.endLocation || selectedProject"
        >
          <div
            v-if="
              !fields.endLocation ||
              (fields.endLocation && !fields.endLocation.long_address)
            "
            class="flex items-center"
          >
            <button
              v-if="selectedProject && Object.keys(selectedProject).length > 0"
              class="mr-2"
              @click="
                () =>
                  $refs.endLocation.selectLocation(
                    processLocationForEmit(selectedProject.location)
                  )
              "
              :class="selectedProject.location ? 'btn-primary' : 'btn-disabled'"
            >
              <span class="label">Tellimusega sama</span>
            </button>
            <button
              v-if="selectedProject && Object.keys(selectedProject).length > 0"
              class="mr-2"
              :class="
                (selectedProject &&
                  selectedProject.client &&
                  selectedProject.client.location) ||
                (selectedProject && selectedProject.client_location)
                  ? 'btn-primary'
                  : 'btn-disabled'
              "
              @click="
                () =>
                  $refs.endLocation.selectLocation(
                    processLocationForEmit(
                      selectedProject.client && selectedProject.client.location
                        ? selectedProject.client.location
                        : selectedProject.client_location
                    )
                  )
              "
            >
              <span class="label">Tellimuse kliendiga sama</span>
            </button>
            <button
              v-if="fields.location"
              class="btn-primary mr-2"
              @click="
                () =>
                  $refs.endLocation.selectLocation(
                    processLocationForEmit(fields.location)
                  )
              "
            >
              <span class="label">Sama mis algus</span>
            </button>
          </div>
          <div
            v-if="selectedProject && selectedProject.contacts"
            class="flex items-center gap-x-1 ml-auto flex-wrap relative"
          >
            <div
              class="inline-block cursor-pointer"
              v-for="(contact, index) in selectedProject.contacts"
              :key="`end${index}`"
              @mouseenter="contactHovered = `end${index}`"
              @mouseleave="contactHovered = null"
              @click.stop.prevent="
                appendToEndInfo(`${contact.name}: ${contact.telephone_number}`)
              "
            >
              <div
                class="flex p-1 h-6 w-6 rounded shadow bg-primary justify-center items-center"
              >
                <span class="typcn typcn-phone text-white" />
              </div>
              <div
                v-if="contactHovered === `end${index}`"
                class="flex flex-col z-10 absolute p-1 -left-48 top-0 bg-white w-48 border rounded-md"
              >
                <div class="flex items-center justify-between">
                  <span class="font-medium">{{ contact.name }} </span>
                  <span>{{ contact.role }} </span>
                </div>
                <span>
                  {{ contact.telephone_number }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlanningLocationSelector from "@/components/tasks/planning/PlanningLocationSelector";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    PlanningLocationSelector,
  },
  data() {
    return {
      contactHovered: null,
    };
  },
  methods: {
    processLocationForEmit(inputLocation) {
      let location = JSON.parse(JSON.stringify(inputLocation));
      delete location["uuid"];
      return location;
    },
    setStartLocation(location) {
      this.$refs.startLocation.selectLocation(location);
    },
    setEndLocation(location) {
      this.$refs.endLocation.selectLocation(location);
    },
    appendToStartInfo(contactInfo) {
      if (!this.$refs.startLocation.info) {
        this.$refs.startLocation.info = contactInfo;
      } else {
        this.$refs.startLocation.info += `; ${contactInfo}`;
      }
    },
    appendToEndInfo(contactInfo) {
      if (!this.$refs.endLocation.info) {
        this.$refs.endLocation.info = contactInfo;
      } else {
        this.$refs.endLocation.info += `; ${contactInfo}`;
      }
    },
    switchLocations() {
      const startLocation = this.fields.location;
      this.$refs.endLocation.selectLocation(
        this.processLocationForEmit(startLocation)
      );
      this.$refs.startLocation.selectLocation(
        this.processLocationForEmit(this.fields.endLocation)
      );
    },
  },
  computed: {
    ...mapState({
      fields: (state) => state.modals.addTaskModal.fields,
      extraLocations: (state) => state.modals.addTaskModal.extraLocations,
    }),
    ...mapGetters({
      isManager: "companyData/isManager",
      isAdmin: "companyData/isAdmin",
      selectedProject: "modals/addTaskModal/project",
    }),
  },
};
</script>
<style lang="scss"></style>
